<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue" @cancel="preventLeavingWithUnsavedChanges">
        <FormGroupNew label="Merchant-ID"
                      :description="__('integrations.mc.config.merchant_id')"
                      :error="config.errors.mc_merchant_id"
                      :required="requiredFields.includes('mc_merchant_id')">
            <input type="text" class="form-control" v-model="config.mc_merchant_id">
        </FormGroupNew>
        <FormGroupNew :label="__('integrations.mc.config.label.store_code')"
                      :description="__('integrations.mc.config.store_code')"
                      :error="config.errors.mc_store_code"
                      :required="requiredFields.includes('mc_store_code')">
            <input type="text" class="form-control" v-model="config.mc_store_code">
        </FormGroupNew>

        <div v-if="Permission.ACCESS_ADMIN_PANEL">
            <FormGroupNew :label="__('integrations.mc.config.label.only_inventory')"
                          :error="config.errors.mc_only_inventory"
                          :required="requiredFields.includes('mc_only_inventory')">
                <ToggleModel active="bg-primary" v-model="config.mc_only_inventory"/>
            </FormGroupNew>

            <FormGroupNew :label="__('integrations.mc.config.label.full_coverage')"
                          :error="config.errors.mc_full_coverage"
                          :required="requiredFields.includes('mc_full_coverage')">
                <ToggleModel active="bg-primary" v-model="config.mc_full_coverage"/>
            </FormGroupNew>

            <FormGroupNew :label="__('integrations.mc.config.label.ybd_redirect')"
                          :error="config.errors.mc_ybd_redirect"
                          :required="requiredFields.includes('mc_ybd_redirect')">
                <ToggleModel active="bg-primary" v-model="config.mc_ybd_redirect"/>
            </FormGroupNew>

            <FormGroupNew :label="__('integrations.mc.config.label.use_single_requests')"
                          :error="config.errors.mc_use_single_requests"
                          :required="requiredFields.includes('mc_use_single_requests')">
                <ToggleModel active="bg-primary" v-model="config.mc_use_single_requests"/>
            </FormGroupNew>
        </div>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import Errors from "@components/Errors.vue";
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import ToggleModel from '@components/ToggleModel.vue'
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import {PermissionsMixin} from '@js/permissions';

export default {
    components: {FormGroupNew, ToggleModel, IntegrationStoreSettingsLayout, Errors},

    mixins: [IntegrationStoreConfigMixin, PermissionsMixin]
}
</script>
